export default __webpack_public_path__ + "static/media/ss.1c422f30.svg";